define('lq/events/actions/deleteDynamicContentCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function DeleteDynamicContentCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(DeleteDynamicContentCommand, EventAction);

    DeleteDynamicContentCommand.typeName = 'DeleteDynamicContentCommand';

    DeleteDynamicContentCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    DeleteDynamicContentCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'DeleteDynamicContent',
            command: this.eventData.command
        };
    };

    DeleteDynamicContentCommand.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    DeleteDynamicContentCommand.prototype.handleError = function (eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    return DeleteDynamicContentCommand;
});
